export default __webpack_public_path__ + "static/media/analytic.e437233e.svg";